import Pages from './pages';
import './assets/style/reset.scss';
import 'animate.css';
import 'assets/style/animation.scss';
import 'assets/style/utils.scss';
function App() {
  return <Pages />;
}

export default App;
